import { select } from '@ngneat/elf';
import { selectAllEntities } from '@ngneat/elf-entities';
import { createRequestDataSource } from '@ngneat/elf-requests';
import { auditProposalSuppliersStore } from './audit-proposal-suppliers.store';

export const getAuditProposalSuppliersDataSource = createRequestDataSource({
  store: auditProposalSuppliersStore,
  data$: () => auditProposalSuppliersStore.pipe(selectAllEntities()),
  requestKey: 'getAuditsProposal',
  dataKey: 'auditProposalSuppliers',
});


export const getAuditsProposalSupplierDetails = createRequestDataSource({
  store: auditProposalSuppliersStore,
  data$: () => auditProposalSuppliersStore.pipe(select((state) => state.auditsProposalSupplierDetails)),
  requestKey: 'getAuditsProposalSupplierDetails',
  dataKey: 'auditsProposalSupplierDetails',
});

export const getAuditsOfferSupFromProposalSupDataSource = createRequestDataSource({
  store: auditProposalSuppliersStore,
  data$: () => auditProposalSuppliersStore.pipe(select((state) => state.allAuditsOfferSupFromProposalSup)),
  requestKey: 'getAuditsOfferSupFromProposalSup',
  dataKey: 'allAuditsOfferSupFromProposalSup',
});

export const getAllAuditsOfferSupProposalDataSource = createRequestDataSource({
  store: auditProposalSuppliersStore,
  data$: () => auditProposalSuppliersStore.pipe(select((state) => state.allAuditsSupProposal)),
  requestKey: 'getAllAuditsSupProposal',
  dataKey: 'allAuditsSupProposal',
});